import styled from 'styled-components';

export const ModuleInfoContainer = styled.div`
    display: flex;
    gap: 12px;
    flex-direction: column;
    border-radius: 6px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    padding: 12px 16px;
    background-color: rgba(0, 0, 0, 0.04);
`;

export const ModuleTitle = styled.span`
    font-size: 20px;
    font-weight: 700;
`;

export const ModuleSubtitle = styled.span`
    font-size: 12px;
    font-weight: 500;
    opacity: 0.5
`;

export const ModuleDescription = styled.p`
    font-size: 14px;
    font-weight: 500;
    opacity: 0.7
`;

export const ModuleAdditionalInfoContainer = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    border-radius: 6px;
    border: 1px dashed #fa541c;
    padding: 12px 16px;
    opacity: 0.7;
`;